import { createManagedResource } from "./resourceCreator"

const api_url = import.meta.env.VITE_API_URL

export const createManagedCollection = function (abortController, collection) {

    let manageCollection = {}

    Object.keys(collection).map(name => {
        manageCollection[name] = createManagedResource(name, collection[name], api_url, abortController)
    })

    return manageCollection
}
